import React from 'react';
import { css } from '@emotion/core';
import childrenPropTypes from '../proptypes/children';

const svgCss = css`
  display: block;
  height: 0;
  padding-top: 100%;
  position: relative;
  width: 100%;

  svg {
    left: 0;
    position: absolute;
    top: 0;
  }
`;

const ResponsiveSvg = ({ children }) => (
  <span css={svgCss}>
    {children}
  </span>
);

ResponsiveSvg.propTypes = {
  children: childrenPropTypes.isRequired,
};

export default ResponsiveSvg;
